import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export function LoginFAQ() {
  return (
    <div className="mt-8">
      <h2 className="text-xl font-bold text-primary-dark text-center mb-6">
        الأسئلة الشائعة
      </h2>

      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value="item-1">
          <AccordionTrigger className="text-right">
            التسجيل في الخدمات الإلكترونية
          </AccordionTrigger>
          <AccordionContent className="text-gray-600">
            <p className="mb-2">
              قم بتعبئة النموذج في الرابط التالي وسيتم إضافتكم للخدمات الإلكترونية بإذن الله
            </p>
            <Button 
              variant="link" 
              className="text-primary hover:text-primary/80 p-0 h-auto font-semibold"
              asChild
            >
              <a href="/register">
                <ExternalLink className="h-4 w-4 ml-1" />
                اضغط هنا
              </a>
            </Button>
          </AccordionContent>
        </AccordionItem>

        {/* <AccordionItem value="item-2">
          <AccordionTrigger className="text-right">
            رقم جوالي غير سعودي
          </AccordionTrigger>
          <AccordionContent className="text-gray-600">
            <p>
              أدخل رقم جوالك المسجل لدينا وأضف عليه مفتاح الدولة، مثال: 96654xxxx71
            </p>
          </AccordionContent>
        </AccordionItem> */}
      </Accordion>
    </div>
  );
}